import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Avatar from "@mui/material/Avatar";
import "./ForgotPassword.css"

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/sign-in/forgot-password`,
        { email }
      );
      
      Swal.fire({
        title: "Email Sent!",
        text: "An OTP have been sent to your email.",
        icon: "success",
      });
      
      if (response.status === 200) {
        navigate(`/otp-verify?email=${encodeURIComponent(email)}`);
      }
    } catch (error) {
      setIsLoading(false);
      
      let errorMessage = "An error occurred while processing your request.";
      
      if (error.response) {
        const status = error.response.status;
        
        if (status === 404) {
          errorMessage = "No account found with this email address.";
        } else if (status === 500) {
          errorMessage = "Server error. Please try again later.";
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
      
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <button className="back-button" onClick={() => navigate("/login")}>
          <ArrowBackIcon /> Back to Login
        </button>
        
        <div className="forgot-password-header">
          <Avatar className="forgot-password-avatar">
            <LockOutlinedIcon />
          </Avatar>
          <h1>Find Your Account</h1>
          <p>Enter your email and we'll send you a recover OTP</p>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="input-group">
            <EmailOutlinedIcon className="input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <button type="submit" disabled={isLoading} className="submit-button">
            {isLoading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>

        <div className="forgot-password-footer">
          <p>
            Remember your password? <a href="/login">Sign In</a>
          </p>
          <p>
            Don't have an account? <a href="/sign-up">Create Account</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;